import { useMutation } from '@tanstack/react-query';
import { saveMFASettings } from '../services/fn-api/User';

export interface UserMFASettingsModel {
  isMFAEnabled: boolean;
  userId: number;
}

export const useSaveUserMFASettings = () => {
  return useMutation<void, Error, UserMFASettingsModel>({
    mutationFn: async (mfaSettings: UserMFASettingsModel) => {
      return saveMFASettings(mfaSettings);
    },
  });
};
